"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const rum_1 = require("@yandex-int/pythia-libs/lib/rum");
const selectors_1 = require("src/redux/sagas/selectors");
const actions_1 = require("src/redux/actions");
const settings_1 = require("src/hooks/settings");
const question_choice_1 = __importDefault(require("src/components/question-choice"));
const question_rating_1 = __importDefault(require("src/components/question-rating"));
const question_emotion_1 = __importDefault(require("src/components/question-emotion"));
const question_scale_1 = __importDefault(require("src/components/question-scale"));
const widget_markup_1 = __importDefault(require("src/components/widget-markup"));
const page_video_styles_1 = __importDefault(require("./page-video.styles"));
const b = b_1.default.with('page');
const QUESTION_COMPONENTS = {
    choice: question_choice_1.default,
    rating: question_rating_1.default,
    scale: question_scale_1.default,
    emotion: question_emotion_1.default
};
const WIDGET_COMPONENTS = {
    markup: widget_markup_1.default
};
const PageWidget = (_a) => {
    var { key } = _a, widget = __rest(_a, ["key"]);
    if (!widget.visible) {
        return null;
    }
    const WidgetComponent = WIDGET_COMPONENTS[widget.type];
    return WidgetComponent && (0, jsx_runtime_1.jsx)(WidgetComponent, Object.assign({}, widget), key);
};
// eslint-disable-next-line max-statements, complexity
const PageQuestion = (_a) => {
    var { key, theme, lang } = _a, question = __rest(_a, ["key", "theme", "lang"]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const nextBtnBehavior = (0, settings_1.useNextBtnBehaviour)();
    const charLimits = (0, settings_1.useCharLimits)();
    const options = { nextBtnBehavior, charLimits };
    if (!question.visible) {
        return null;
    }
    question.questionIndex = question.id;
    switch (question.type) {
        case 'choice': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.target.value));
            };
            question.handleClickOther = () => {
                dispatch((0, actions_1.clickOtherQuestion)(question.id));
            };
            question.handleClickOtherWithText = () => {
                dispatch((0, actions_1.clickOtherWithTextQuestion)(question.id));
            };
            question.handleChangeOtherWithText = e => {
                dispatch((0, actions_1.changeOtherWithTextQuestion)(question.id, e.target.value, options));
            };
            question.handleBlurOtherWithText = e => {
                dispatch((0, actions_1.blurQuestionText)(question.id, e.target.value, options));
            };
            question.handleClickNoAnswer = () => {
                dispatch((0, actions_1.clickNoAnswerQuestion)(question.id));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            break;
        }
        case 'scale': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.currentTarget.dataset.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            break;
        }
        case 'rating': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.target.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            break;
        }
        case 'emotion': {
            question.handleClickOption = e => {
                dispatch((0, actions_1.clickOptionQuestion)(question.id, e.currentTarget.dataset.value));
            };
            question.handleClickNoOpinionAnswer = () => {
                dispatch((0, actions_1.clickNoOpinionAnswerQuestion)(question.id));
            };
            break;
        }
        default: {
            break;
        }
    }
    const QuestionComponent = QUESTION_COMPONENTS[question.type];
    return (QuestionComponent && (0, jsx_runtime_1.jsx)(QuestionComponent, Object.assign({}, question, { theme: theme, lang: lang }), key));
};
function PageChild({ child, questions, widgets, groups, theme, lang }) {
    switch (child.type) {
        case 'question': {
            const question = questions[child.id];
            const props = Object.assign(Object.assign({}, question), { theme,
                lang, key: `${child.type}-${child.id}`, errors: (0, selectors_1.getQuestionErrors)(question) });
            return PageQuestion(props);
        }
        case 'widget': {
            const widget = widgets[child.id];
            const props = Object.assign(Object.assign({}, widget), { key: `${child.type}-${child.id}` });
            return PageWidget(props);
        }
        case 'group': {
            const group = groups[child.id];
            const props = Object.assign(Object.assign({}, group), { key: child.id });
            return PageGroup(props);
        }
        default:
            return null;
    }
}
function PageGroup(group) {
    if (group.type === 'transparent') {
        return group.children.map(child => ((0, jsx_runtime_1.jsx)(PageChild, { child: child }, `${child.id}-${child.type}`)));
    }
    return null;
}
const Page = props => {
    const { children, questions, widgets, groups, theme, lang, displayMode, mode, nextPageIndex, nextBtnLabel, pageNumber, renderVendorLabel, renderNextButton } = props;
    (0, react_2.useEffect)(() => {
        if (process.env.NODE_ENV !== 'storybook' && window.Ya.Rum.sendHeroElement) {
            (0, rum_1.sendFirstMeaningfulPaint)();
        }
    }, []);
    const isPageContentWide = Object.keys(questions).some(qId => questions[qId].imageAlign);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b({
            theme,
            'display-mode': displayMode,
            wide: isPageContentWide ? 'yes' : 'no',
            mode,
            first: pageNumber === 0 ? 'yes' : 'no',
            last: nextPageIndex === -1 ? 'yes' : 'no'
        }) }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: page_video_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('questions') }, { children: children.map(c => ((0, jsx_runtime_1.jsx)(PageChild, { child: c, questions: questions, widgets: widgets, groups: groups, theme: theme, lang: lang }, `${c.id}-${c.type}`))) })), renderVendorLabel(), renderNextButton({ label: nextBtnLabel })] })));
};
Page.defaultProps = {
    children: [],
    pageNumber: 0,
    questions: {},
    widgets: {},
    groups: {},
    theme: 'default',
    lang: 'ru',
    displayMode: 'default',
    mode: '',
    nextPageIndex: 1
};
exports.default = Page;
